import { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import { Button, Card } from "react-bootstrap";
import { showErrorMessage } from "@beeldit/core/helpers/messagesHelper";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useDetailsAction from "../actions/details/useDetailsAction";
import { DetailsActionContext } from "../actions/details/DetailsActionContext";
import PageLoadErrorState from "@bloonde/cms/cms-pages/components/PageLoadErrorState";
import useRepairMissingSections from "@bloonde/cms/cms-pages/actions/repairMissingSections/useRepairMissingSections";

function PageEditionPage() {
  let { pageId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  if (!pageId) {
    pageId = "0";
  }

  const numericPageId = parseInt(pageId, 10);

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate: detailsActionTemplate,
  } = useDetailsAction(parseInt(pageId));
  const { pageLoadError } = useContext(DetailsActionContext);
  const { repairing, repairMissingSections } = useRepairMissingSections();
  const [repairingSectionId, setRepairingSectionId] = useState<number | null>(null);

  const listPath = location.pathname.replace(/\/[^/]+$/, "");
  const retryLoad = () => getFunction(numericPageId);
  const navigateToList = () => navigate(listPath);
  const canRepairPage = Boolean(
    pageLoadError?.canRepairMissingSections && numericPageId > 0
  );
  const reloadPage = () => window.location.reload();
  const repairSection = async (section: any) => {
    const endpoint =
      section?.repairEndpoints?.byPageId ??
      `pages/${numericPageId}/sections/${section.sectionId}/repair-content`;

    if (!endpoint) {
      showErrorMessage("No se encontro un endpoint de reparacion para esta seccion");
      return;
    }

    setRepairingSectionId(section.sectionId);

    try {
      await repairMissingSections(numericPageId, { endpoint }, reloadPage);
    } finally {
      setRepairingSectionId(null);
    }
  };
  const repairPage = () =>
    repairMissingSections(
      numericPageId,
      { endpoint: `pages/${numericPageId}/repair-missing-sections` },
      reloadPage
    );

  useEffect(() => {
    getFunction(numericPageId);
  }, [pageId]);

  return (
    <Card>
      <Card.Body className="PageEditContainer">
        {pageLoadError ? (
          <PageLoadErrorState
            title={pageLoadError.title}
            detail={pageLoadError.detail}
            onRetry={retryLoad}
            onBack={navigateToList}
            onRepair={canRepairPage ? repairPage : undefined}
            repairing={repairing}
            repairableSections={pageLoadError.repairableSections}
            onRepairSection={repairSection}
            repairingSectionId={repairingSectionId}
          />
        ) : (
          detailsActionTemplate
        )}
      </Card.Body>

      {!pageLoadError ? (
        <Card.Footer className="d-flex py-4">
          <Button variant="primary" size="lg" className="ms-auto" onClick={onSubmitFunction}>
            {t("save_changes")}
          </Button>
        </Card.Footer>
      ) : null}
    </Card>
  );
}

export default PageEditionPage;
